module.exports = __webpack_public_path__ + "img/contatc_us.72f93e48.png";